import { skipToken } from '@apollo/client/react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useGetTag } from 'src/services/apollo/tag'
import { useQs } from 'src/utils/qs'
import { useContestConfig } from '../Contest/useContestConfig'

export const useTagInfo = (name?: string) => {
  const { t } = useTranslation(['common'])
  const contestConfig = useContestConfig()
  const { data: tag } = useGetTag(name ?? skipToken)

  const [qs] = useQs()

  const challenge = +qs?.challenge

  return useMemo(() => {
    if (name === 'challenge') {
      const tag = contestConfig?.find(contest => {
        return contest.cid === challenge
      })
      if (!tag)
        return {
          name,
        }
      return {
        name: t(`common:contest.contest-name`, {
          name: t(`common:contest.tag.${tag.name}.name`, {
            defaultValue: tag.name,
          }),
        }),
        description: t(`common:contest.tag.${tag.name}.description`, {
          defaultValue: null,
        }),
        selectedContestTag: tag,
      }
    }

    if (!tag) return { name }

    return {
      name: tag.displayName ?? tag.name,
      description: tag.extra?.description,
    }
  }, [contestConfig, name, challenge, tag, t])
}

export type TagInfo = ReturnType<typeof useTagInfo>
